export const IntakeStatusCardTestIds = {
  DISMISS_BUTTON: 'intake-card.dismiss-button',
  CANCEL_BUTTON: 'intake-card.cancel-button',
  REVIEW_BUTTON: 'intake-card.review-button',
  PROGRESS_DRAWER: 'intake-card.progress-drawer',
};
